module.exports = __webpack_public_path__ + "static/images/envelope.b6ef6b796ac3037a67d86daacaddb14c.svg";